import { render, staticRenderFns } from "./GridUsuario.vue?vue&type=template&id=0bd3bc8c&"
import script from "./GridUsuario.vue?vue&type=script&lang=js&"
export * from "./GridUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports